import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Award } from 'lucide-react';
import { toast } from 'sonner';

const LoanCertificatesReport = () => {
  const navigate = useNavigate();
  const [closedLoans, setClosedLoans] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchClosedLoans(); }, []);

  const fetchClosedLoans = async () => {
    setLoading(true);
    try {
      const resp = await api.get('/loans');
      const closed = resp.data.filter(l => l.status === 'closed');
      const branchResp = await api.get('/branches');
      const branchMap = {};
      branchResp.data.forEach(b => { branchMap[b.id] = b.name; });
      closed.forEach(l => { l.branch_name = branchMap[l.branch_id] || ''; });
      setClosedLoans(closed);
    } catch { toast.error('Failed to fetch closed loans'); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-700"></div></div>;

  return (
    <div className="p-4 md:p-6 lg:p-8" data-testid="loan-certificates-report-page">
      <div className="flex items-center gap-3 mb-6">
        <Link to="/reports" className="text-slate-500 hover:text-slate-700"><ArrowLeft className="w-5 h-5" /></Link>
        <div><h1 className="text-2xl font-bold text-slate-900">Loan Closure Certificates</h1><p className="text-sm text-slate-600">{closedLoans.length} closed loan(s) found</p></div>
      </div>

      {closedLoans.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg border border-slate-200">
          <table className="w-full text-sm">
            <thead className="bg-amber-600 text-white"><tr><th className="px-3 py-2 text-left">Loan ID</th><th className="px-3 py-2 text-left">Entrepreneur</th><th className="px-3 py-2 text-left">Branch</th><th className="px-3 py-2 text-left">Loan Type</th><th className="px-3 py-2 text-right">Amount</th><th className="px-3 py-2 text-center">Disbursement</th><th className="px-3 py-2 text-center">Actions</th></tr></thead>
            <tbody>
              {closedLoans.map((loan, idx) => (
                <tr key={loan.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                  <td className="px-3 py-2 font-medium">{loan.loan_id}</td>
                  <td className="px-3 py-2">{loan.entrepreneur_name}</td>
                  <td className="px-3 py-2">{loan.branch_name || '-'}</td>
                  <td className="px-3 py-2">{loan.loan_type}</td>
                  <td className="px-3 py-2 text-right">Rs.{loan.loan_amount.toLocaleString('en-IN')}</td>
                  <td className="px-3 py-2 text-center">{new Date(loan.disbursement_date).toLocaleDateString('en-IN')}</td>
                  <td className="px-3 py-2 text-center">
                    <Button size="sm" variant="outline" className="text-amber-700 border-amber-300 hover:bg-amber-50" onClick={() => navigate(`/loans/${loan.id}`)} data-testid={`view-cert-${loan.loan_id}`}>
                      <Award className="w-3 h-3 mr-1" /> View & Generate
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-12 text-slate-500"><Award className="w-12 h-12 mx-auto mb-3 text-slate-300" /><p>No closed loans found. Certificates are generated when loans are fully repaid.</p></div>
      )}
    </div>
  );
};

export default LoanCertificatesReport;
